import { useCallback, useMemo, useContext } from 'react';
import { io } from 'socket.io-client';
import { useHistory } from 'react-router-dom';
import GraniteError from 'granite-admin/utils/granite-error';
import { getAuthToken } from 'granite-admin/utils/auth-singleton';
import { getGrandEmitter } from 'granite-admin/utils/grandEmitter';
import { ConfigContext } from 'granite-admin/core/components/ConfigProvider';
let websocketInstance = null;
function getPath(data, route) {
  const arr = route.split('/');
  const vars = arr.filter(a => a.includes(':')).map(a => a.replace(':', ''));
  vars.forEach(v => route = route.replace(':' + v, data[v]));
  return route; //in case generatePath not works
}

function useWebSocketIO(props) {
  const config = useContext(ConfigContext);
  const authToken = getAuthToken();
  const {
    history
  } = useHistory();
  const grandEmitter = useMemo(() => getGrandEmitter(), []);
  const {
    websocketMappings = null
  } = config || {};
  const initEvents = useCallback(handlers => {
    const {
      onConnectionOpen,
      onConnectionClose,
      onGetMessage,
      onGetError,
      onJoinRoom,
      onLeaveRoom
    } = handlers || {};
    if (websocketInstance) {
      websocketInstance.on('connect', () => {
        console.log('onGetMessage', onGetMessage);
        if (typeof onConnectionOpen === 'function') {
          onConnectionOpen(websocketInstance);
        } else {
          console.log('Websocket connection is established', websocketInstance.connected);
        }
      });
      websocketInstance.on('connect_error', e => {
        if (typeof onGetError === 'function') {
          onGetError(e);
        } else {
          console.log('Getting error over Websocket connection: ', e);
        }
      });
      websocketInstance.on('disconnect', reason => {
        if (typeof onConnectionClose === 'function') {
          onConnectionClose(reason);
        } else {
          console.log('Websocket connection is closed', reason);
        }
      });
      websocketInstance.on('message', eventData => {
        if (websocketMappings && websocketMappings[eventData.action]?.showToast) {
          let redirectUrl = '';
          if (websocketMappings[eventData.action]?.autoRedirect && websocketMappings[eventData.action]?.redirectUrl) {
            redirectUrl = getPath(eventData.data, websocketMappings[eventData.action].redirectUrl);
          }
          grandEmitter.emit('SHOW_TOAST', {
            message: websocketMappings[eventData.action]?.toastMsg,
            status: 'info',
            ...(websocketMappings[eventData.action]?.autoRedirect && websocketMappings[eventData.action]?.redirectUrl && {
              redirect: () => history.push(redirectUrl)
            })
          });
        }
        if (websocketMappings && websocketMappings[eventData.action]?.volatileStorage) {
          localStorage.setItem(eventData.action, eventData.data);
        }
        if (typeof onGetMessage === 'function') {
          onGetMessage(eventData);
        } else {
          console.log('Getting data over Websocket connection: ', eventData);
        }
      });
      websocketInstance.on('join', e => {
        if (typeof onJoinRoom === 'function') {
          onJoinRoom(e);
        } else {
          console.log('Joined Room: ', e);
        }
      });
      websocketInstance.on('leave', e => {
        if (typeof onLeaveRoom === 'function') {
          onLeaveRoom(e);
        } else {
          console.log('Leave Room: ', e);
        }
      });
    }
  }, []);
  const loadWebsocketInstance = useCallback(url => {
    try {
      const webSocketUrl = url || process.env.REACT_APP_WEBSOCKET_IO_URL || '';
      if (webSocketUrl && authToken) {
        websocketInstance = io(webSocketUrl, {
          extraHeaders: {
            Authorization: `Bearer ${authToken}`
          }
        });
      }
    } catch (e) {
      throw new GraniteError(e);
    }
  }, [authToken]);
  const sendData = data => {
    try {
      if (websocketInstance.connected) {
        websocketInstance.send(data);
      } else {
        console.log('websocket connection is not established');
      }
    } catch (e) {
      throw new GraniteError(e);
    }
  };
  const joinRoom = data => {
    try {
      if (websocketInstance.connected) websocketInstance.emit('join', data);
    } catch (e) {
      throw new GraniteError(e);
    }
  };
  const LeaveRoom = data => {
    try {
      if (websocketInstance.connected) websocketInstance.emit('leave', data);
    } catch (e) {
      throw new GraniteError(e);
    }
  };
  const closeConnection = () => {
    try {
      //if the connection is open and no data is queued for sending
      if (websocketInstance.connected) websocketInstance.disconnected();
    } catch (e) {
      throw new GraniteError(e);
    }
  };
  return {
    websocketInstance,
    loadWebsocketInstance,
    initEvents,
    sendData,
    closeConnection,
    joinRoom,
    LeaveRoom
  };
}
export default useWebSocketIO;